import ConfigSeoApi from "../configs/ConfigSeoApi";
import Cookies from "js-cookie";

// Custom pages live in the seo service (Mongo `custom_page`), not in cms-api:
// the page is keyed by language + the full site path, and the same service
// already serves it to the front, so the CMS talks to it directly the way it
// talks to blog-api for article images.
const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getPages = (lang) =>
  ConfigSeoApi.get("/api/admin/pages", { params: { lang }, headers: headers() });

// The admin read, not the public one: it answers for a hidden page too.
const getPage = (lang, alias) =>
  ConfigSeoApi.get(`/api/admin/pages/${lang}`, { params: { url: alias }, headers: headers() });

const upsertPage = (data) =>
  ConfigSeoApi.post("/api/admin/pages", data, { headers: headers() });

const deletePage = (lang, alias) =>
  ConfigSeoApi.delete(`/api/admin/pages/${lang}`, { params: { url: alias }, headers: headers() });

const uploadImage = ({ lang, alias, file, alt }) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("alt", alt || "");
  return ConfigSeoApi.post(`/api/admin/pages/${lang}/image`, formData, {
    params: { url: alias },
    headers: { ...headers(), "Content-Type": "multipart/form-data" },
  });
};

export default {
  getPages,
  getPage,
  upsertPage,
  deletePage,
  uploadImage,
};
